module.exports = __webpack_public_path__ + "media/images/pic/anime/music-fffee30ca1951143af20c6b7794c087c.svg";